<script lang="ts">
  import Star from '../../../../assets/svgs/star.svelte';
  export let reviewText: string | undefined = '';
  export let reviewerName: string | undefined = '';

  let structuredData = {
    '@context': 'https://schema.org/',
    '@type': 'Review',
    author: {
      '@type': 'Person',
      name: reviewerName,
    },
    reviewRating: {
      '@type': 'Rating',
      ratingValue: '5.0',
    },
    reviewBody: reviewText,
    itemReviewed: {
      '@type': 'SoftwareApplication',
      name: 'Sweat',
      applicationCategory: 'HealthApplication',
      operatingSystem: 'IOS, ANDROID',
    },
  };

  let structuredDataBlock = `<script type="application/ld+json">${JSON.stringify(structuredData)}<\/script>`;
</script>

<div
  class="flex flex-col justify-start items-center text-center px-4 lg:px-0 max-h-[400px] lg:max-h-[310px] overflow-y-auto"
>
  <div class="flex flex-row justify-center items-center">
    <Star svgClass="scale-75 sm:scale-100 mr-0 sm:mr-6" /><Star
      svgClass="scale-75 sm:scale-100 mr-0 sm:mr-6"
    /><Star svgClass="scale-75 sm:scale-100 mr-0 sm:mr-6" /><Star
      svgClass="scale-75 sm:scale-100 mr-0 sm:mr-6"
    /><Star svgClass="scale-75 sm:scale-100" />
  </div>
  <div
    class="flex flex-col flex-wrap justify-center items-center py-8 sm:py-10 w-full lg:max-w-800"
  >
    <p
      class="text-gray-900 font-semibold text-lg sm:text-display-xxs pb-8 break-words w-full lg:max-w-800"
    >
      {reviewText}
    </p>
    <p class="text-gray-500 font-semibold text-lg break-words w-full lg:max-w-800">
      {reviewerName}
    </p>
  </div>

  {@html structuredDataBlock}
</div>
